// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import AutoResearchController from "./auto_research_controller"
application.register("auto-research", AutoResearchController)

import SpendChartController from "./spend_chart_controller"
application.register("spend-chart", SpendChartController)
